






































import { isViewAsSelected } from "@/store/modules/TargetUserModule";
import { Vue, Component, Prop } from "vue-property-decorator";

import ReportItemComponent from "./ReportItem.vue";
import Report from "@/data/models/Report";
import { doesClientHaveApp } from "@/data/repository/ClientRepository";
import { calculateBackgroundStyle, StorageKeyLastVisitedItemLevel } from "@/utils/Utils";
import { COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";

@Component({
  components: {
    report: ReportItemComponent,
  },
})
export default class ReportListComponent extends Vue {
  hasApp = doesClientHaveApp();
  forceUpdateBackgroundColor = false;

  @Prop()
  reports!: Array<Report>;

  @Prop({ default: false })
  isPortalOnlyProject!: boolean;

  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  showDeleteReportButton(report: Report) {
    // Never while "Sicht auf" is active (ticket 2610051).
    return !isViewAsSelected() && !this.hasApp && this.reports[0]?.id !== report?.id;
  }

  onOpenReport() {
    this.forceUpdateBackgroundColor = !this.forceUpdateBackgroundColor;
  }

  onOpenPdeViewer(report: Report) {
    this.$emit("openPdeViewer", report);
  }

  onOpenBeschreibungViewer(report: Report) {
    this.$emit("openBeschreibungViewer", report);
  }

  calculateBackgroundStyle(reportId: string) {
    return calculateBackgroundStyle(reportId, StorageKeyLastVisitedItemLevel.LEVEL_5);
  }
}
